import { DefineDevice, KIO, KeyMap, OutputMode, Record, VirtualIrokFe87V2 } from '@hid/define/define'
import { DeviceMapKey } from './device'
import { dataProfileManage } from '@hid/snapshot/profile'
import { DVKFromVK, kkFromVK } from '@hid/define/define_fn'
import { splitIntoBytes } from '../tool'
import defineType from '@hid/define/define_type'
import i18n from '@/languages/i18n'
import { deviceManager } from '@hid/device/device_manager'
const { t } = i18n.global

class Fe87V2 implements DeviceMapKey {
  encodeKey(params: KIO): KeyMap {
    if (params.Output.Mode != OutputMode.Key) {
      throw new Error('Not Key Mode')
    }

    let layout = fe87V2Layout.FN0
    if (params.Input.WithFN) {
      layout = fe87V2Layout.FN1
    }

    if (defineType.isMedia(params.Output.VK)) {
      const dvk = DVKFromVK(params.Output.VK, VirtualIrokFe87V2)
      const [consumerLowByte, consumerHighByte] = splitIntoBytes(dvk)
      return [params.Input.KK, layout, consumerLowByte, consumerHighByte]
    }

    if (defineType.isMouse(params.Output.VK)) {
      const dvk = DVKFromVK(params.Output.VK, VirtualIrokFe87V2)
      const [consumerLowByte, consumerHighByte] = splitIntoBytes(dvk)
      return [params.Input.KK, layout, consumerLowByte, consumerHighByte]
    }

    let setKey = kkFromVK(params.Output.VK, deviceManager.deviceID)
    if (setKey == undefined) {
      //throw new Error('Not Found Key : ' + params.Output.VK)
      throw new Error(t('please_select_invalid_key'))
    }

    return [params.Input.KK, layout, setKey, 0x00]
  }

  macroData(params: KIO): number[] {
    const macro = dataProfileManage().dataProfile.Macros.get(params.Output.DataIndex)
    if (macro == undefined) {
      throw new Error('macro is undefined')
    }

    const data = Array(11).fill(0)

    //data[0] = params.Input.KK;
    data[0] = fe87V2Layout.MODE
    data[1] = fe87V2SetMode.Macro
    data[2] = 0x00

    data[3] = params.Input.KK
    data[4] = fe87V2Layout.Macro_addr
    data[5] = params.Output.DataIndex
    data[6] = 0x00

    data[7] = params.Input.KK
    data[8] = fe87V2Layout.Macro_long
    data[9] = macro.length
    data[10] = 0x00

    return data
  }

  macroDataConfig(params: KIO): number[] {
    const macro = dataProfileManage().dataProfile.Macros.get(params.Output.DataIndex)
    if (macro == undefined) {
      throw new Error('macro is undefined')
    }

    let count = 1
    if (params.Output.Extension[0] > 1) {
      count = 65535
    } else if (params.Output.Extension[0] == 1) {
      count = params.Output.Extension[1]
    }

    console.log('params', params)

    let mode = params.Output.Extension[0]
    if (params.Output.Extension[0] == 2) {
      mode = 1
    }
    if (params.Output.Extension[0] == 3) {
      mode = 2
    }

    const [consumerLowByte, consumerHighByte] = splitIntoBytes(count) //max 65530
    const data = Array(8).fill(0)

    data[0] = params.Output.DataIndex
    data[1] = 0x00
    data[2] = macro.length

    data[3] = mode // 宏循环方式
    data[4] = consumerLowByte // 重复次数
    data[5] = consumerHighByte

    data[6] = 0x01 // 重复间隔
    data[7] = 0x00
    data[8] = 0x00

    return data
  }

  genarateMacroData(data: Record, keyDataLen: number): number[] {
    let key = kkFromVK(data.Key, deviceManager.deviceID)
    if (key == undefined) {
      //throw new Error('Not Found Key : ' + data.Key)
      throw new Error(t('please_select_invalid_key'))
    }

    const data16bit_low: number = key & 0xff
    const data16bit_high: number = (key >> 8) & 0xff

    const keyState: number = data.Press ? 1 : 8
    const keyDelay: number = data.Delay

    const buffer = new ArrayBuffer(keyDataLen)
    const view = new DataView(buffer)

    view.setUint8(0, data16bit_low)
    view.setUint8(1, data16bit_high)

    if (keyDataLen == 6) {
      const combined = (keyState << 24) | keyDelay
      view.setUint8(2, combined & 0xff)
      view.setUint8(3, (combined >> 8) & 0xff)
      view.setUint8(4, (combined >> 16) & 0xff)
      view.setUint8(5, (combined >> 24) & 0xff)
    } else {
      // 将 4bit 数据和 12bit 数据组合成 16bit 数据
      const combined = (keyState << 12) | keyDelay
      view.setUint8(2, combined & 0xff)
      view.setUint8(3, (combined >> 8) & 0xff)
    }

    return Array.from(new Uint8Array(buffer))
  }

  // private Na87ProFnDisableKeys: Map<number, number[]> = new Map([
  //     [58, [148, 17]],
  //     [59, [35, 18]],
  //     [60, [138, 17]],
  //     [61, [131, 17]],
  //     [62, [182, 16]],
  //     [63, [181, 16]],
  //     [64, [205, 16]],
  //     [65, [183, 16]],
  //     [66, [233, 16]],
  //     [67, [234, 16]],
  //     [68, [226, 16]],
  //     [69, [146, 17]],
  //     [71, [16, 243]],
  //     [73, [17, 243]],
  //     [76, [0, 241]],
  //     [82, [18, 243]],
  //     [80, [21, 243]],
  //     [81, [19, 243]],
  //     [79, [20, 243]],
  //     [4, [1, 241]],
  //     [22, [2, 241]],
  //     [227, [9, 243]],
  // ])

  getFnDisableKeysData(device: DefineDevice): Map<number, number[]> {
    console.log('getFnDisableKeysData', device)
    return new Map<number, number[]>()
  }
}

export const fe87V2Data = new Fe87V2()

const enum fe87V2Layout {
  FN0 = 0x00,
  FN1 = 0x01,
  FN2 = 0x02,
  FN3 = 0x03,
  DB0 = 0x04,
  DB1 = 0x05,
  DB2 = 0x06,
  DB3 = 0x07,
  MODE = 0x08,
  DKS1 = 0x09,
  DKS2 = 0x0a,
  DKS3 = 0x0b,
  DKS4 = 0x0c,
  TRPS1 = 0x0d,
  TRPS2 = 0x0e,
  TRPS3 = 0x0f,
  TRPS4 = 0x10,
  Macro_addr = 0x11,
  Macro_long = 0x12,
  MT_TGL = 0x13,
  RT_press = 0x14,
  RT_release = 0x15,
}

const enum fe87V2SetMode {
  global = 0x00,
  single = 0x01,
  Macro = 0x06,
  Combi = 0x10,
  longPress = 0x80,
}
